import classnames from 'classnames/bind';
import React from 'react';
import styles from 'presentation/components/styles/__demo__/DropDownSearchResults.css';
import PropTypes from 'prop-types';
import AnswerItemContainer from 'presentation/containers/__demo__/AnswerItemContainer';

let cx = classnames.bind(styles);

class DropDownSearchResults extends React.Component {
  constructor(props) {
    super(props);

    const DropDownSearchResultsPropTypes = {
      currentFocusIndex: PropTypes.number.isRequired,
      searchResults: PropTypes.array,
      shouldShowDropDown: PropTypes.bool,
      value: PropTypes.string.isRequired,
    };
    PropTypes.checkPropTypes(DropDownSearchResultsPropTypes, props, 'prop', 'DropDownSearchResults');
  }

  render() {
    let dDSRClasses = cx(styles.dropDownSearchResults);
    if (this.props.shouldShowDropDown && this.props.searchResults.length > 0) {
      return (
        <div className={dDSRClasses}>
          {this.props.searchResults.map((answer, currentIndex) => (
            <AnswerItemContainer
              answerId={answer.id}
              currentFocusIndex={this.props.currentFocusIndex}
              focusIndex={currentIndex}
              isSearchedAnswer={true}
              key={answer.id}
              name={answer.name.toString()}
              onBlur={this.props.onBlur}
            />
          ))}
        </div>
      );
    } else {
      return null;
    }
  }
}

export default DropDownSearchResults;
